import { contractTypeEnum } from "./enums";

export type ContractTypeApi =
  | "b2B"
  | "employmentContract"
  | "contractOfMandate";

const apiToEnum: Record<ContractTypeApi, contractTypeEnum> = {
  b2B: contractTypeEnum.B2B,
  employmentContract: contractTypeEnum.EmploymentContract,
  contractOfMandate: contractTypeEnum.ContractOfMandate,
};

export const contractTypePl: Record<contractTypeEnum, string> = {
  [contractTypeEnum.B2B]: "Umowa B2B",
  [contractTypeEnum.EmploymentContract]: "Umowa o pracę",
  [contractTypeEnum.ContractOfMandate]: "Umowa zlecenie",
};

export function parseContractType(
  value: ContractTypeApi | null | undefined
): contractTypeEnum | null {
  if (value === null || value === undefined) {
    return null;
  }
  return apiToEnum[value] ?? null;
}

export function getContractTypeLabel(
  value: ContractTypeApi | null | undefined
): string {
  const parsed = parseContractType(value);
  if (parsed === null) {
    return "—";
  }
  return contractTypePl[parsed];
}

export function isPayoutOnlyContract(
  value: ContractTypeApi | null | undefined
): boolean {
  const parsed = parseContractType(value);
  return (
    parsed === contractTypeEnum.B2B
    || parsed === contractTypeEnum.ContractOfMandate
  );
}

export function isEmploymentContract(
  value: ContractTypeApi | null | undefined
): boolean {
  return parseContractType(value) === contractTypeEnum.EmploymentContract;
}
